import { render, staticRenderFns } from "./BodyPartAdd.vue?vue&type=template&id=d60ca006&"
import script from "./BodyPartAdd.vue?vue&type=script&lang=js&"
export * from "./BodyPartAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports